
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-3e79cd4a\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Trash.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Trash.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3e79cd4a\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Trash.vue"),
  /* scopeId */
  "data-v-3e79cd4a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/admin/Trash.vue
// module id = 597
// module chunks = 1